export default __webpack_public_path__ + "images/logoAquareveal.b2113f51d696ca39a5d8a197909476a5.svg"